import { createAction, props } from '@ngrx/store';

import { featureKey } from '../definitions';

export interface SetLocaleProps {
  bcpLocale: string;
}

export const setLocaleAction = createAction(`${featureKey} - set locale`, props<SetLocaleProps>());
export const setLockedLocaleAction = createAction(`${featureKey} - set and lock locale`, props<SetLocaleProps>());
export const loadLocaleAction = createAction(`${featureKey} - load locale`, props<SetLocaleProps>());
export const localeLoadedAction = createAction(`${featureKey} - locale loaded`, props<SetLocaleProps>());
